// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"8dc3e60f","215":"8dc3e60f","256":"8dc3e60f","515":"8dc3e60f","646":"8dc3e60f","987":"8dc3e60f"}[chunkId] + ".chunk.css";
};